import {SchemaCollaborator} from 'auth/PermissionConstants';
import * as net from 'util/Net';

import {CollaboratorInfoGraphQL} from '../../../graphql-fragments/auth/__generated/CollaboratorInfoGraphQL';
import {ConnectionSchemaSpec} from './ConnectionSchemaConstants';

export function connectionSchemasURL(): string {
  return `/connection-schemas`;
}

export function createConnectionSchemaURL(): string {
  return `/connection-schemas/create`;
}

export function connectionSchemaURL(schemaId: string): string {
  return `/connection-schemas/${schemaId}`;
}
interface BulkArchiveResponse {
  archivedItemIds: Array<string>;
}

export function bulkArchive(ids: Array<string>, purpose: string): Promise<BulkArchiveResponse> {
  return net.postJSONPromise({
    url: '/1/api/connection-schemas:bulk-archive',
    data: {ids, purpose},
  });
}

interface BulkUnarchiveResponse {
  unarchivedItemIds: Array<string>;
}

export function bulkUnarchive(ids: Array<string>): Promise<BulkUnarchiveResponse> {
  return net.postJSONPromise({
    url: '/1/api/connection-schemas:bulk-unarchive',
    data: {ids},
  });
}

export function updateConnectionSchema(args: {
  schemaId: string;
  schemaName: string;
  sqlIdentifier: string | null;
  spec: ConnectionSchemaSpec;
}): Promise<{schemaId: string}> {
  return net.patchJSONPromise({
    url: `/1/api/connection-schemas/${args.schemaId}`,
    data: {schemaName: args.schemaName, sqlIdentifier: args.sqlIdentifier, spec: args.spec},
  });
}

export function createConnectionSchema(args: {
  name: string;
  ownerId: string;
  sqlIdentifier: string | null;
  spec: ConnectionSchemaSpec;
  collaborators?: Array<SchemaCollaborator>;
  adapterId: string;
}): Promise<{schemaId: string}> {
  return net.postJSONPromise({
    url: `/1/api/connection-schemas`,
    data: args,
  });
}

export interface UpdateSchemaCollaboratorsRequest {
  collaborators: Array<SchemaCollaborator>;
}

interface UpdateSchemaCollaboratorsResponse {
  schema: CollaboratorInfoGraphQL;
}

export function updateCollaborators(
  schemaId: string,
  data: UpdateSchemaCollaboratorsRequest
): Promise<UpdateSchemaCollaboratorsResponse> {
  return net.patchJSONPromise({url: `/1/api/connection-schemas/${schemaId}/collaborators`, data});
}
